var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.56,
    y1: 21.96,
    x2: 39.2,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 17.94,
    y1: 55.73,
    x2: 26.94,
    y2: 71.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 28.81,
    y1: 49.45,
    x2: 37.81,
    y2: 65.04,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 37.06,
    y1: 44.68,
    x2: 46.06,
    y2: 60.27,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 17.94,
    y1: 49.73,
    x2: 26.94,
    y2: 65.32,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 28.81,
    y1: 43.45,
    x2: 37.81,
    y2: 59.04,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 37.06,
    y1: 38.68,
    x2: 46.06,
    y2: 54.27,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5,31.5l-.32,0a10.49,10.49,0,0,0-19.11-8,7,7,0,0,0-10.57,6,7.21,7.21,0,0,0,.1,1.14A7.5,7.5,0,0,0,18,45.5a4.19,4.19,0,0,0,.5,0v0h28a7,7,0,0,0,0-14Z",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 58,
    x2: 21.5,
    y2: 58,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#b)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    y1: 58,
    x2: 39,
    y2: 58,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    strokeDasharray: "7 7",
    stroke: "url(#c)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 58,
    x2: 47,
    y2: 58,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#d)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-3 0; 3 0; -3 0",
    dur: "5s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 52,
    x2: 21.5,
    y2: 52,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#e)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    y1: 52,
    x2: 39,
    y2: 52,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    strokeDasharray: "7 7",
    stroke: "url(#f)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 52,
    x2: 47,
    y2: 52,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#g)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-3 0; 3 0; -3 0",
    dur: "5s",
    begin: "-4s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaze);
export default __webpack_public_path__ + "static/media/haze.65aacb88285c2155ecc91e3cacb74766.svg";
export { ForwardRef as ReactComponent };